import { render, staticRenderFns } from "./DelayNodeConfig.vue?vue&type=template&id=36a6fee0&scoped=true"
import script from "./DelayNodeConfig.vue?vue&type=script&lang=js"
export * from "./DelayNodeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a6fee0",
  null
  
)

export default component.exports